import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { LogoImg } from "./Logo";
import { COMPANY, SERVICES, NAV_LINKS, MORE_LINKS } from "../../data/site";
import { useSiteConfig } from "./SiteConfig";

const Col = ({ title, links }) => (
  <div>
    <h2 className="eyebrow !text-brand-200 mb-4">{title}</h2>
    <ul className="space-y-2">
      {links.map(([to, label]) => (
        <li key={to}><Link to={to} className="text-white/85 hover:text-white transition-colors text-[15px]" data-testid={`footer-link-${to.replace(/[/?=]/g, "-").slice(1)}`}>{label}</Link></li>
      ))}
    </ul>
  </div>
);

const LEGAL = [["/mentions-legales", "Mentions légales"], ["/cgv", "CGV"], ["/confidentialite", "Confidentialité"], ["/cookies", "Cookies"]];

export const Footer = () => {
  const { phone } = useSiteConfig();
  return (
    <footer data-testid="site-footer" className="relative bg-navy text-white overflow-hidden">
      <svg aria-hidden="true" className="absolute right-0 top-0 h-full w-1/2 opacity-[0.07]" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M0 60 L100 10 L100 24 L0 74 Z" fill="#9DB8D6" />
      </svg>
      <div className="relative container-x py-16 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4 space-y-5">
          <Link to="/" data-testid="footer-logo" aria-label="Habitalys — accueil"><LogoImg variant="full-white" height={64} /></Link>
          <p className="text-white/75 max-w-sm text-[15px]">Conseil & AMO pour adapter, sécuriser et rénover les logements. Les travaux sont réalisés par des entreprises tierces qualifiées et assurées.</p>
          <ul className="space-y-2.5 text-[15px]">
            <li className="flex gap-3" data-testid="footer-address"><MapPin className="h-5 w-5 text-brand-200 shrink-0 mt-0.5" aria-hidden="true" /><span>{COMPANY.street}, {COMPANY.city}</span></li>
            <li className="flex gap-3"><Mail className="h-5 w-5 text-brand-200 shrink-0 mt-0.5" aria-hidden="true" /><a href={`mailto:${COMPANY.email}`} className="link-u" data-testid="footer-email">{COMPANY.email}</a></li>
            {phone && <li className="flex gap-3"><Phone className="h-5 w-5 text-brand-200 shrink-0 mt-0.5" aria-hidden="true" /><a href={`tel:${phone.replace(/\s/g, "")}`} className="link-u" data-testid="footer-phone">{phone}</a></li>}
          </ul>
        </div>
        <div className="lg:col-span-8 grid gap-10 sm:grid-cols-3">
          <Col title="Services" links={SERVICES.map((s) => [`/services/${s.slug}`, s.title])} />
          <Col title="Habitalys" links={[...NAV_LINKS, ...MORE_LINKS].map((l) => [l.to, l.label])} />
          <Col title="Contact" links={[["/contact", "Demander un devis"], ["/contact?type=rappel", "Être rappelé"], ["/prendre-rdv", "Prendre RDV diagnostic"], ["/simulateur", "Tester mon éligibilité"]]} />
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="container-x py-5 flex flex-col lg:flex-row gap-3 lg:items-center lg:justify-between text-sm text-white/70">
          <nav aria-label="Informations légales" data-testid="footer-legal-bar" className="flex flex-wrap gap-x-5 gap-y-2">
            {LEGAL.map(([to, l]) => <Link key={to} to={to} className="hover:text-white" data-testid={`legal-link-${to.slice(1)}`}>{l}</Link>)}
            <button type="button" className="hover:text-white" onClick={() => window.dispatchEvent(new Event("habitalys:cookies"))} data-testid="legal-manage-cookies">Gérer les cookies</button>
          </nav>
          <p data-testid="footer-legal">© {new Date().getFullYear()} Habitalys — {COMPANY.form} au capital de {COMPANY.capital} — SIREN <span data-testid="footer-siren">{COMPANY.siren}</span> — {COMPANY.rcs}</p>
        </div>
      </div>
    </footer>
  );
};
